import { render, staticRenderFns } from "./Records.vue?vue&type=template&id=39ddb6f3&scoped=true"
import script from "./Records.vue?vue&type=script&lang=js"
export * from "./Records.vue?vue&type=script&lang=js"
import style0 from "./Records.vue?vue&type=style&index=0&id=39ddb6f3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ddb6f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39ddb6f3')) {
      api.createRecord('39ddb6f3', component.options)
    } else {
      api.reload('39ddb6f3', component.options)
    }
    module.hot.accept("./Records.vue?vue&type=template&id=39ddb6f3&scoped=true", function () {
      api.rerender('39ddb6f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/payments/Records.vue"
export default component.exports